const isHigherRatio = (currentWidth, currentHeight) => {
  let ratio = currentWidth / currentHeight;

  if (currentHeight > currentWidth) {
    ratio = currentHeight / currentWidth;
  }

  return ratio > 1.6;
};

const adjustScale = (baseWidth = 1280, baseHeight = null, flip = true) => {
  const currentWidth = window.innerWidth;
  const currentHeight = window.innerHeight;
  const scaleX = currentWidth / baseWidth;
  const scaleY = (baseHeight && currentHeight / baseHeight) || null;
  let scale = scaleX;

  if (flip) {
    if (scaleY && scaleY < scaleX) {
      scale = scaleY;
    }

    if (isHigherRatio(currentWidth, currentHeight)) {
      // This should be considered additionally
      // scale *= 0.9;
    }
  }

  return scale;
};

export default adjustScale;
